export default __webpack_public_path__ + "static/media/logo4.1884580b.svg";